import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import {minDate} from "../../Constants/Constants"

const AddPrivateLocalOrderDetails = ({ formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [storeProduct, setStoreProduct] = useState([]);
  const [product, setProduct] = useState("");
  // const [productName, setProductName] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({
    product_id: "",
    product_name: "",
  });
  // const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [party, setParty] = useState([]);
  const [partyName, setPartyName] = useState("");
  const [privateRate, setPrivateRate] = useState([]);

  const [rowAddData, setRowAddData] = useState({
    party_name: "",
    rate: 0,
    gst_percent: "",
    date: "",
    received_date: "",
    remarks: "",
    total_order_qty: "",
  });
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handlePartyChange = (e) => {
    setPartyName(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleProductChange = (event) => {
    if (event.target.value) {
      const selectedProductValue = JSON.parse(event.target.value);
      const { product_id, product_name } = selectedProductValue;
      setSelectedProduct({ product_id, product_name });
    } else {
      setSelectedProduct({ product_id: "", product_name: "" });
    }
  };

  function resetFields() {
    setRowAddData({
      party_name: "",
      rate: "",
      gst_percent: "",
      date: "",
      received_date: "",
      remarks: "",
      total_order_qty: "",
    });
    setYardID("");
    setSelectCompanyId("");
    setSelectedCompanyId("");
    // setProductId("");
    setPartyName("");
    setSelectedProduct("");
    // setProductName("");
  }

  const getProductDetails = async (e) => {
    setSelectedCompanyId(e.target.value);
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: e.target.value,
      }),
    });
    const result = await res.json();
    // console.log(result.data)
    setProduct(result.data);
  };

  const getSingleYardDetailClosing = async () => {
    const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${selectedProduct.product_id}&yard_id=${yardId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setClosingStockInYard(result.data);
    } else {
      setClosingStockInYard("");
    }
  };

  useEffect(() => {
    if (yardId) {
      getSingleYardDetailClosing();
    }
  }, [yardId]);

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      party_name,
      date,
      remarks,
      rate,
      gst_percent,
      received_date,
      total_order_qty,
    } = rowAddData;
    let BASE_URL =
      SERVER_URL + `/api/private-local/local-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        product_name_id: selectedProduct.product_id,
        party_name: partyName,
        remarks,
        date,
        rate,
        gst_percent,
        received_date,
        // order_details: orderNumbers,
        total_order_qty,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getParty = async () => {
    const BASE_URL =
      SERVER_URL + `/api/private-rate/all-private-rate/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setParty(result.data);
    } else {
      setParty([]);
    }
  };

  useEffect(() => {
    getParty();
  }, []);

  const getPrivateRate = async () => {
    const BASE_URL = `${SERVER_URL}/api/private-rate/drop-private-rate/${user_id}?party_name=${partyName}&product_name=${selectedProduct.product_name}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setPrivateRate(result.data);
    } else {
      setPrivateRate(null);
    }
  };

  useEffect(() => {
    if (partyName && selectedProduct.product_name) {
      getPrivateRate();
    }
  }, [partyName, selectedProduct]);

  useEffect(() => {
    setRowAddData((prevData) => ({
      ...prevData,
      rate: privateRate ? privateRate.private_rate : 0,
    }));
  }, [privateRate]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="private-local-order"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="private-local-orderLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Private Order
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={(e) => {
                                getProductDetails(e);
                              }}
                              value={selectedCompanyId}
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="product">Product Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleProductChange}
                              value={JSON.stringify(selectedProduct)}
                              id="product"
                              required
                              disabled={!selectedCompanyId}
                            >
                              <option value="">Select Product Name</option>
                              {product &&
                                product.length &&
                                product.map((item, id) => {
                                  return (
                                    <option
                                      value={JSON.stringify({
                                        product_id: item.id,
                                        product_name: item.size,
                                      })}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party_name">Party Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="party_name"
                              id="party_name"
                              onChange={handlePartyChange}
                              value={partyName}
                              required
                            >
                              <option value="">Select Party Name</option>
                              {party &&
                                party?.length > 0 &&
                                party?.map((item, id) => (
                                  <option
                                    value={item.party_name}
                                    key={id}
                                  >{`${item.party_name}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="date"
                                id="Date"
                                placeholder="Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="received_date">Received Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="received_date"
                                id="received_date"
                                placeholder="Enter received date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.received_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="total_order_qty">
                              Total Order Qty
                            </label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_order_qty"
                                id="total_order_qty"
                                placeholder="Total order qty"
                                onChange={handleChange}
                                value={rowAddData.total_order_qty}
                                required
                                min="1"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="rate"
                                id="rate"
                                autoComplete="off"
                                placeholder="Enter rate"
                                onChange={handleChange}
                                value={rowAddData.rate}
                                required
                                min="1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="gst_percent">GST %</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="gst_percent"
                                id="gst_percent"
                                autoComplete="off"
                                placeholder="Enter gst percent"
                                onChange={handleChange}
                                value={rowAddData.gst_percent}
                                // required
                                min="1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="remarks"
                                autoComplete="off"
                                placeholder="Enter remarks"
                                onChange={handleChange}
                                value={rowAddData.remarks}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {orderNumbers.map((order, index) => {
                        return (
                          <div key={index} className="row">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="Company">Company Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.company_id}
                                  onChange={(e) =>
                                    handleCompanyChange(e, index)
                                  }
                                  id="Company"
                                >
                                  <option value="">Select Company</option>
                                  {company.map((item, id) => (
                                    <option
                                      key={id}
                                      value={item.id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="product">Product Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.product_name_id}
                                  onChange={(e) =>
                                    handleProductChange(e, index)
                                  }
                                  disabled={!selectCompanyId}
                                  id="product"
                                >
                                  <option value="">Select Product</option>
                                  {product &&
                                    product[index]?.map((item, id) => (
                                      <option
                                        key={id}
                                        value={item.id}
                                      >{`${item.size}`}</option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="yard">Yard Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={order.yard_id}
                                  onChange={(e) => handleYardChange(e, index)}
                                  disabled={!selectCompanyId}
                                  id="yard"
                                >
                                  <option value="">Select yard</option>
                                  {yard &&
                                    yard[index]?.map((item, id) => (
                                      <option
                                        key={id}
                                        value={item.id}
                                      >{`${item.yard_name}`}</option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="QTY">Order Quantity</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={order.order_qty}
                                    autoComplete="off"
                                    onChange={(e) => handleQtyChange(e, index)}
                                    placeholder="Order Quantity"
                                    id="QTY"
                                  />
                                  <span className="input-group-append ml-2">
                                    <div className="col-md-2">
                                      {index > 0 ? (
                                        <button
                                          type="button"
                                          title="Remove"
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          disabled
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                        >
                                          <i className="mdi mdi-close" />
                                        </button>
                                      )}
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })} */}
                      {/* <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPrivateLocalOrderDetails;
